var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[(_vm.appropriateComponent)?_c(_vm.appropriateComponent,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }